import React from "react";

const RoadmapCard = (props) => {
  const data = props.data;
  return (
    <div className="RoadmapCard row align-items-center">
      <div className={`col-md-6 ${data.order1}`}>
        <img src={data.imageSrc} alt="" />
      </div>
      <div className={`col-md-6 ${data.order2}`}>
        <p className="text-white mb-1" style={{ fontWeight: 600 }}>
          {data.subHeading}
        </p>
        <h1 className="sectionHeading">
          <span>{data.heading}</span>
        </h1>
        <p className="para">{data.para}</p>
        <p className="text-white mb-1" style={{ fontWeight: 600 }}>
          {data.subHeading2}
        </p>
        <h1 className="sectionHeading">
          <span>{data.heading2}</span>
        </h1>
        <p className="para">{data.para2}</p>
        {data.list ? (
          <ul>
            {" "}
            {data.list.map((item) => (
              <li>{item}</li>
            ))}
          </ul>
        ) : (
          ""
        )}
      </div>
      <div className="borderLine"></div>
      <div className="iconParent">
        <div className="icon">
          <i className={data.icon}></i>
        </div>
      </div>
    </div>
  );
};
export default RoadmapCard;
